import axios from "axios";

export const retrieveStandards = ({
    commit
}) => {
    axios.get("/standards.json").then(response => {
        commit("standards", response.data);
        commit("filteredStandards", response.data.data);
    });
};